//@ts-nocheck
import { getConfig } from "../../config/config";
const { APP_BASE_CHARTSLAYOUT_API_URL } = getConfig();
const reqUrl = new URL(window.location);
const osParam = reqUrl.searchParams.get("osName");
export const getAutoSavePrefData = async (platform) => {
    const ClientCode = localStorage.getItem("ClientCode");
    const Authorization = osParam === "Android" || osParam === "iOS" || osParam === "flutter"
        ? "Bearer " +
            localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
        : "Bearer " + localStorage.getItem("JWTToken");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", Authorization);
    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };
    try {
        const response = await fetch(`${APP_BASE_CHARTSLAYOUT_API_URL}api/user-preferences?user=${ClientCode}&plateform=${platform}`, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    }
    catch (error) {
        console.error("Error fetching auto-save preferences:", error);
        throw error;
    }
};
